import {DialogTypes} from 'common/names';
import {ConfirmDialogData} from 'components/dialogs/ConfirmDialog';
import {ICloseSubDialogAction} from 'features/layout/redux/actions';
import i18n from 'i18n';
import {call} from 'redux-saga/effects';
import {openDialogWithResult} from './openDialogWithResult';

export function* openConfirmDialog(title: string, content?: string) {
   const dialogResult: ICloseSubDialogAction<boolean> = yield call(openDialogWithResult, {
      id: DialogTypes.ConfirmDialog.id,
      data: {
         title,
         content,
         cancelLabel: i18n.t('No'),
      } as ConfirmDialogData,
   });

   return !!dialogResult.payload?.data;
}
